// code for excute api
module.exports = {
    DM_TINHTP: 'DsTinhTp',
    DM_QUANHUYEN: 'DsQuanHuyen',
    DM_PHUONGXA: 'DsPhuongXa',
    DM_NHOMDANTOC: 'DmNhomDanToc',
    DM_DANTOC: 'DmDanToc',
    DM_LOAIDIADIEM: 'DmLoaiDiadiem',
    DM_PHANLOAIDIADIEM: 'DmPhanloaiDiadiem',
    DM_KY: 'DmKy',
    MENU: 'Menu',
    QUANTRI_QUYENMENU: 'RolesMenu',
    QUANTRI_QUYEN: 'Roles',

    QUANTRI_DONVI: 'DsDonVi',
    DANHMUC_TINHTP: 'DsTinhTp',
    DANHMUC_QUANHUYEN: 'DsQuanHuyen',
    DANHMUC_PHUONGXA: 'DsPhuongXa',
    DANHMUC_KHOMAP: 'DsKhomAp',
    DANHMUC_TODANPHO: 'DsToDanPho',
    DANHMUC_DUONGPHO: 'DsDuongPho',
    DANHMUC_CHUCDANH: 'DmChucDanh',
    DM_CONGTY: 'CongTy',

    DM_TRINHDOCHUYENMONY: 'DmTrinhdochuyenmonY',
    DM_TRINHDOCHUYENMONCOSODUOC: 'DmTrinhdochuyenmonCosoduoc',
    DM_LOAIHINHHANHNGHEY: 'DmLoaihinhHanhngheY',
    DM_HINHTHUCKINHDOANHCOSODUOC: 'DmHinhthuckinhdoanhCosoduoc',
    DM_CHUYENKHOAY: 'DmChuyenkhoaY',
    CSYT_BENHVIEN: 'BenhVien',
    CSYT_COSODUOC: 'CosoDuoc',
    CSYT_COSOYTETUNHAN: 'CosoYteTunhan',
    CSYT_TRAMYTE: 'TramYTe',

    DM_TIEUCHUANKHACHSAN: 'DmTieuchuanKhachsan',

    DM_GD_MONHOC: 'DmMonHoc',
    DM_GD_CAPHOC: 'DmCapHoc',
    DM_GD_MUCTRUONGCHUAN: 'DmMucTruongchuan',
    DM_GD_QUYMOTRUONGCHUAN: 'DmQuymoTruongchuan',
    DM_GD_KYTHIHSG: 'DmKyThiHsg',
    DM_GD_THANHTICHHSG: 'DmThanhTichHsg',
    DM_GD_PHANLOAITRUONG: 'DmPhanloaiTruongchuan',
    DM_GD_PHANLOAITRUONG_MAMNON: 'DmPhanloaiTruongMamnon',
    DM_GD_LOAIHINHTRUONG_MAMNON: 'DmLoaihinhTruongMamnon',

    GD_TRUONGCHUANQG: 'DsTruongchuanQuocgia',
    GD_TRUONGMAMNON_QGGD: 'DsTruongMamnon',
    GD_HOCSINHGIOI: 'DsHocSinhGioi',
    GD_TRUONGCHUANQUOCGIALOPHOC: 'TruongchuanQuocgiaLophoc',
    GD_TRUONGCHUANQUOCGIAPHONGHOC: 'TruongchuanQuocgiaPhonghoc',
    GD_TRUONGCHUANQUOCGIAGIAOVIEN: 'TruongchuanQuocgiaGiaovien',
    GD_TRUONGMAMNONPHONGHOC: 'TruongMamnonPhonghoc',
    GD_TRUONGMAMNONGIAOVIEN: 'TruongMamnonGiaovien',
    GD_TRUONGMAMNONHOCSINH: 'TruongMamnonHocsinh',
    GD_TRUONGCHUANQUOCGIAHOCSINH: 'TruongchuanQuocgiaHocsinh',
    GD_TRUONGMAMNONLOPHOC: 'TruongMamnonLophoc',
    GD_BAOCAOGD: 'BcGiaoDuc',

    DM_LOAIDITICH_VH: 'DmLoaiDitich',
    DM_LOAIHINHDITICH_VH: 'DmLoaihinhDitich',
    DM_BOMONTHETHAO_VH: 'DmThethaoBomon',
    DM_CHITIEUTHETHAO_VH: 'DmThethaoChitieu',
    DM_HANGCANTHETHAO_VH: 'DmThethaoHangcan',
    DM_PHAMVIGIAITHETHAO_VH: 'DmThethaoPhamvi',
    DM_NHOMGIAITHIDAUTHETHAO_VH: 'DmThethaoNhomgiai',
    DM_NHOMTHANHTICHTHETHAO_VH: 'DmThethaoNhomThanhtich',

    DL_DITICH_DIVAT: 'VanhoaDitichDisan',
    DL_DIEMDULICH: 'VanhoaDiemDuLich',
    DL_HOATDONGDULICH: 'HoatdongDulich',

    TT_GIAITHIDAUTHETHAO: 'DmThethaoGiaithidau',
    TT_THANHTICHTHIDAUTHETHAO: 'DmThethaoThanhtich',
    TT_HUANLUYENVIENTHETHAO: 'DsHuanLuyenVien',
    TT_HUANLUYENVIENBOMONTHETHAO: 'DsHlvBmtd',
    TT_VANDONGVIENTHETHAO: 'DsVanDongVien',
    TT_VANDOGNVIENBOMONTHETHAO: 'DsVdvBmtd',
    TT_THANHTICHCANHANTHETHAO: 'DsThethaoThanhtichCanhan',
    TT_THANHTICHTONGHOPTHETHAO: 'DsThethaoThanhtichTonghop',
    TT_PHONGTRAOTHETHAO: 'ThethaoPhongtrao',
    TT_DOITHETHAO: 'DsThethaoDoi',
    TT_THANHTICHDONGDOITHETHAO: 'DsThethaoThanhtichDongdoi',
    TT_SUNGHIEPTHETHAO: 'ThethaoSunghiep',


    VH_BAOLUCGIADINH: 'VanhoaBaolucGiadinh',
    VH_GIADINHVANHOA: 'VanhoaGiadinhVanhoa',


    DM_NGANHANG: 'DmNganHang',
    CSTY_ATM: 'Atm',
    CSTY_KHACHSAN: 'KhachSan',
    CSTY_TRAMXANG: 'TramXang',
    CSTY_NHAXE: 'NhaXe',
    CSTY_BENXE: 'BenXe',
    CSTY_DIEMTIENICH: 'DiemTienIch',
    CSTY_DIEMWIFICONGCONG: 'DiemWifiCongCong',
    CSTY_NHAHANG: 'NhaHang',


    DM_HTCS_CONGSUATDEN: 'DmCongsuatDen',
    DM_HTCS_LOAIDEN: 'DmLoaiDen',
    DM_HTCS_LOAITRUDEN: 'DmLoaiTruden',
    DM_HTCS_LOAITUYENDUONG: 'DmLoaiTuyenduong',
    DM_HTCS_TINHTRANGDEN: 'DmTinhtrangDen',
    DM_HTCS_TINHTRANGTRUDEN: 'DmTinhtrangTruden',
    HTCS_TUYENDENDUONG: 'TuyenDenduong',
    HTCS_TRUDENCHIEUSANG: 'TrudenChieusang',
    HTCS_SUACHUADENCHIEUSANG: 'SuachuaDenChieusang',

    DM_XLRT_LOAITUYENDUONGCHIEUSANG: 'LoaiTuyenduongQuetRac',
    DM_XLRT_TUYENDUONGTHUGOMRAC: 'TuyenduongThugomrac',
    DM_XLRT_DIABANTHUGOMRAC: 'DiabanThugomrac',
    XLRT_LICHQUETRAC: 'LichQuetRac',
    XLRT_LICHTHUGOMRAC: 'LichThugomrac',
    XLRT_LICHNAOVETHOGA: 'LichNaovetHoga',
    XLRT_LICHVESINHDOTHIKHAC: 'LichVesinhDothiKhac',



    DM_TCKH_CHITIEUTHUCHINGANSACH: 'DmChitieuThuchiNgansach',
    DM_TCKH_TIENDODAUTU: 'DmTiendoDautu',
    TCKH_THUCHINGANSACH: 'ThuchiNgansach',
    TCKH_NGUONVONDAUTU: 'NguonvonDautu',
    TCKH_DUANDAUTU: 'DuanDautu',
    TCKH_KEHOACHVON: 'KehoachVon',
    TCKH_TIENDOGIAINGAN: 'TiendoGiaingan',
    TCKH_BAOCAOKEHOACHVON: 'BaocaoKehoachvon',
    TCKH_BAOCAOKTXH: 'BaocaoKtxh',
}
